import { useParams } from 'react-router-dom';

import { NavigationLink } from 'app/layout/components/Layout/CoachSidebar/Navigation';
import { CoachSidebarParticipantInfo } from 'app/layout/components/Layout/CoachSidebar/ParticipantInfo';
import { NavigationRoadmapLinks } from 'app/layout/components/Navigation';
import {
  CHAT_WITH_AI_KNOWLEDGE_BASE_FEATURE_FLAG,
  MORPHEUS_OBJECTIVES_DASHBOARD_FEATURE_FLAG,
  RenderIfFFEnabled,
} from 'featureFlags';
import { Box, VStack } from 'shared';
import { iconNames } from 'shared_DEPRECATED/components/Icon';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';

import { SprintNavigation } from 'features/sprint/components/Navigation';
import { sharedSprintLinks } from 'features/sprint/utils';

export const CoachSidebarOpen = () => {
  const { email } = useParams();
  const getNavigationLinkWithParticipantEmail = getNavigationLink(email!);

  return (
    <Box
    // data-state="open"
    // _open={{
    //   animation: 'fadeOut',
    // }}
    >
      <CoachSidebarParticipantInfo />
      <Spacers sizes={['zr zr lg', 'zr zr md']} />
      <VStack gap={1} alignItems="flex-start">
        <RenderIfFFEnabled
          featureFlag={CHAT_WITH_AI_KNOWLEDGE_BASE_FEATURE_FLAG}
        >
          <NavigationLink
            iconConfig={{
              name: iconNames.hub,
            }}
            link={getNavigationLinkWithParticipantEmail('cortex-chat')}
            text="Insights Chat"
            dataTestid="cortex-chat-btn"
          />
        </RenderIfFFEnabled>
        <NavigationLink
          iconConfig={{
            name: iconNames.dashboard,
          }}
          link={getNavigationLinkWithParticipantEmail('dashboard')}
          text="Dashboard"
          dataTestid="dashboard-bnt"
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.sessions,
          }}
          link={getNavigationLinkWithParticipantEmail('sessions')}
          text="Sessions"
          dataTestid="sessions-bnt"
        />
        <RenderIfFFEnabled
          featureFlag={MORPHEUS_OBJECTIVES_DASHBOARD_FEATURE_FLAG}
        >
          <NavigationLink
            iconConfig={{
              name: iconNames.dashboard,
            }}
            link={getNavigationLinkWithParticipantEmail('objectives')}
            text="Objectives"
            dataTestid="objectives-btn"
          />
        </RenderIfFFEnabled>
        <NavigationRoadmapLinks
          linkCallback={getNavigationLinkWithParticipantEmail}
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.group,
          }}
          link={getNavigationLinkWithParticipantEmail('groups')}
          text="Groups"
          dataTestid="groups-btn"
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.resource,
          }}
          link={getNavigationLinkWithParticipantEmail('resource-bank')}
          text="Resource bank"
          dataTestid="resources-btn"
        />
      </VStack>
      <Spacers sizes={['zr zr lg', 'zr zr md']} />
      <Box style={{ borderTop: 'var(--border-secondary)' }} />
      <Spacers sizes={['lg zr zr', 'md zr zr']} />
      <SprintNavigation />
    </Box>
  );
};

const getNavigationLink = (email: string) => (path: string) =>
  `${sharedSprintLinks.participants}/${email}/${path}`;
